/* src/app/common/components/feedback/feedback-form.component.scss */
.smartdine-form {
  padding: 12px;
}
.smartdine-form ion-item {
  --background: #fbfefc;
  border-radius: 8px;
  margin-bottom: 8px;
  --inner-padding-end: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.smartdine-form ion-item ion-label {
  font-weight: 600;
  color: var(--ion-color-primary);
  font-size: 14px;
}
.smartdine-form ion-item ion-input,
.smartdine-form ion-item ion-textarea {
  text-align: left;
  font-size: 14px;
}
.smartdine-form ion-item .rating-star {
  padding-top: 8px;
}
.smartdine-form .required-star {
  color: var(--ion-color-danger);
  margin-left: 4px;
}
.smartdine-form small.error-text {
  color: var(--ion-color-danger);
  display: block;
  font-size: 12px;
  padding: 2px 4px 6px;
  text-align: right;
}
/*# sourceMappingURL=feedback-form.component.css.map */
